// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

import depreciationSchedule from './asset-depreciation-schedule.js';
import allowanceClaim from './asset-allowance-claim.js';

export default [
    {
        path: '/:organisation/accounting/assets/disposed',
        component: () =>
            import('@/pages/[organisation]/accounting/assets/disposed/index.vue'),
        name: 'accounting.asset.disposed-assets',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.asset.update-asset',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/disposed/[id].vue'),
                name: 'accounting.asset.view-disposed-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
        ],
    },
    {
        path: '/:organisation/accounting/assets/sold',
        component: () =>
            import('@/pages/[organisation]/accounting/assets/sold/index.vue'),
        name: 'accounting.asset.sold-assets',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.asset.update-asset',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/sold/[id].vue'),
                name: 'accounting.asset.view-sold-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
        ],
    },
    {
        path: '/:organisation/accounting/assets/retired',
        component: () =>
            import('@/pages/[organisation]/accounting/assets/retired/index.vue'),
        name: 'accounting.asset.retired-assets',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.asset.update-asset',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/retired/[id].vue'),
                name: 'accounting.asset.view-retired-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
        ],
    },

    {
        path: '/:organisation/accounting/assets',
        component: () =>
            import('@/pages/[organisation]/accounting/assets/index.vue'),
        name: 'accounting.asset.search-assets',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.asset.view-assets',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/new.vue'),
                name: 'accounting.asset.create-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.create-asset',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/[id].vue'),
                name: 'accounting.asset.view-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.view-assets',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/[id]/edit.vue'),
                name: 'accounting.asset.update-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
            {
                path: ':id/sell-asset',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/[id]/sell-asset.vue'),
                name: 'accounting.asset.sell-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
            {
                path: ':id/dispose-asset',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/[id]/dispose-asset.vue'),
                name: 'accounting.asset.dispose-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
            {
                path: ':id/revalue-asset',
                component: () =>
                    import('@/pages/[organisation]/accounting/assets/[id]/revalue-asset.vue'),
                name: 'accounting.asset.revalue-asset',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.asset.update-asset',
                },
            },
            ...depreciationSchedule,
            ...allowanceClaim,
        ],
    },
];
